import { ProgressModal } from "@/components/Elements/Feedback/ProgressModal";
import { SubmitButton } from "@/components/Elements/Inputs/Buttons/SubmitButton";
import { useValuation } from "@/features/LG/components/Page3/Valuation/api/useValuation";
import { Customer, CustomerState } from "@/store/customerState";
import { valuatedState, ValuatingInputState } from "@/store/propertyState";
import { RealtorState } from "@/store/realtorState";
import { SubmitHandler, UseFormReturn } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";

interface Props {
  form: UseFormReturn<any, any>;
  next: string;
}

export const ValuationEnterForm: React.FC<Props> = ({ form, next }) => {
  const [customer, setCustomer] = useRecoilState(CustomerState);

  const navigate = useNavigate();
  const { property_type } = useParams();

  const valuatingInput = useRecoilValue(ValuatingInputState);
  const setValuatedResult = useSetRecoilState(valuatedState);
  const [realtor] = useRecoilState(RealtorState);

  const valuation = useValuation();

  const {
    formState: { isValid },
    handleSubmit,
  } = form;

  const onSubmit: SubmitHandler<Customer> = (data) => {
    setCustomer(data);
    valuation.fetch(valuatingInput, (r) => {
      setValuatedResult(r);
      navigate(`/${property_type}/${next}`);
    });
  };

  return (
    <>
      <ProgressModal open={valuation.isLoading} text="査定中..." />
      <SubmitButton
        label="査定価格を見る"
        disabled={!isValid}
        onClick={handleSubmit(onSubmit)}
        color={realtor.color.main}
      />
    </>
  );
};
